import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
// Components
import CarouselContent from 'components/table/carousel/carousel-content'
import SingleStateContent from 'components/table/carousel/single-state-content'
// Data
import carouseService from "data/carousel"
import automationService from "data/automation"
// Icons
import { ThumbtackIcon, ThumbtackSolidIcon } from "images/icons/tools"
// Styles
import { CarouselModal_s, PinIcon_s } from "components/table/carousel/carousel-styles"

interface Props {
  code: string,
  data: CarouselData,
  height?: number,
  width?: number
}

export interface CarouselData {
  controls: object,
  defaults?: object,
  field: string,
  namedItems?: object,
  persist: Function,
  rowData: {},
  show: boolean,
  title: string,
  description?: string
  width?: number
  table?: string
}

const CarouselModal: FC<Props> = (props) => {
  const control_count = Object.keys(props.data.controls).length
  let header:string|null = null
  let heading:string = ""

  let left:string|null = null;
  let top:string|null  = null;
  const currentModal = window.location.pathname;
  const modalLocations = localStorage.getItem('modal_location') ? JSON.parse(localStorage.getItem('modal_location')!) : {}
  if (modalLocations && modalLocations[currentModal]){
    left = modalLocations[currentModal].left;
    top = modalLocations[currentModal].top;
  }
  const [pinned, setPinned] = useState<boolean>(modalLocations && modalLocations[currentModal])
  const [coords, setCoords] = useState<object>({left: left, top: top});

  // ! This hardcoded shit shouldn't be here -- it should be configured on the control, BUT we build the header *before* we know which control it is.
  const isContainer = _.some(['rent-roll/home', 'rent-roll/market-lease', 'multifamily/rent-roll'], (path) => currentModal.includes(path))
  const isStupid = _.some(['n/hospitality/line-items', 'n/hospitality/departmental-line-items', 'n/multifamily/line-items', 'n/mixed-use/line-items', 'n/line-items'], (path) => currentModal.includes(path))
  const state = isContainer || isStupid
    ? _.get(props, `data.rowData.${props.data.field}.state`)
    : _.get(props, `data.rowData.inputtype`)

  if (props.data.field === 'capdetail' || props.data.field === 'floordetail'){
    header = null
  } else if (props.data.field === 'recoverydetail'){
    header = 'Recovery'
  } else if(control_count === 1 && _.get(props.data.controls, 'single.name')) {
    header = _.get(props.data.controls, 'single.name')
  } else if(control_count === 1 && state !== "none" && state !== undefined) {
    header = _.get(props.data.controls, 'single.names')[props.data.rowData[props.data.field].state]
  } else if(state === "none") {
    header = ""
  } else if(state) {
    if (state === '% of Inflation') {
      header = '% of Inflation'
    } else {
      header = props.data.controls[state].name
    }
  } else {
    header = "-"
  }

  if (header) heading = `${(header !== '' && header !== "-") ? ':' : ''} ${header !== "-" ? header : ''}`

  useEffect(() => {
    const automationSubscription = automationService.stream().subscribe(event => {
      switch(true) {
        case event.type === "MODAL_TABBING" || event.type === "MODAL_SHIFT_TABBING":
          carouseService.toggleShow(!props.data.show)
          break
      }
    })

    return function cleanup () {
      automationSubscription.unsubscribe()
    }
  }, [])

  const updateCoords = (left:number, top:number) => {
    setCoords({left, top});
    if (pinned){
      modalLocations[currentModal] = {left, top}
      localStorage.setItem('modal_location', JSON.stringify(modalLocations));
    }
  }

  function togglePin():void {
    const modalDiv = document.getElementById('carouselModal')!.children[0];
    if (modalLocations[currentModal] && modalLocations[currentModal].left){
      modalLocations[currentModal] = null
      setCoords({left: null, top: null});
    } else {
      let left = modalDiv['style'].left
      if (modalDiv['style'].left.endsWith('px')) left = modalDiv['style'].left.substr(0, left.length - 2);
      let top = modalDiv['style'].top
      if (modalDiv['style'].top.endsWith('px')) top = modalDiv['style'].top.substr(0, top.length - 2);
      modalLocations[currentModal] = { left, top }
      setCoords({left: modalDiv['style'].left, top: modalDiv['style'].top});
    }
    localStorage.setItem('modal_location', JSON.stringify(modalLocations));
    setPinned(!pinned);
  }

  const code = _.get(_.get(props, "data.rowData"), _.get(props, "code"))
  let description = _.get(props, "data.description")
  if(!description) description = _.get(code, "length") > 20 ? code.slice(0, 20) + "..." : code

  return (
    <CarouselModal_s
      canMove="carouselModal"
      height={props.height}
      width={props.width}
      show={true}
      divStyle={coords['top'] ? {'top': `${coords['top']}px`, 'left': `${coords['left']}px`} : undefined}
      updateCoords={updateCoords}
      title={`${description} | ${props.data.title} ${heading}`}
      toggleShow={() => {
        carouseService.toggleShow(!props.data.show)
        automationService.broadcast("MODAL_CLOSING", {})
      }}>
      <a onClick={togglePin} title={ pinned ? 'Unpin dialog' : 'Pin dialog' }>
        { pinned ? <PinIcon_s src={ThumbtackSolidIcon} /> : <PinIcon_s src={ThumbtackIcon} /> }
      </a>
      { !_.isNil(header) ? <CarouselContent controls={props.data.controls} field={props.data.field} data={props.data.rowData} persist={props.data.persist} namedItems={props.data.namedItems} defaults={props.data.defaults} table={props.data.table} />
      : <SingleStateContent controls={props.data.controls} field={props.data.field} data={props.data.rowData} persist={props.data.persist} namedItems={props.data.namedItems} defaults={props.data.defaults} table={props.data.table} /> }
    </CarouselModal_s>
  )
}

export default CarouselModal
